import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { AppError } from "../app-error/app-error.model";

import { LimitsReminderAction } from "./limits-reminder.action";
import { LimitsReminderConfigService } from "./limits-reminder.config";
import { LimitsReminderService } from "./limits-reminder.service";

// TODO: This SDK should be moved to common
/**
 * @deprecated -[fabric-deprecated] - Use limits-reminder-service from app-account instead.
 * */
@Injectable()
export class LimitsReminderEffect {
	showLimitsReminderOnLogout$ = createEffect(() =>
		this.actions$.pipe(
			ofType(LimitsReminderAction.fetchBeforeLogout),
			map(() =>
				this.config.isLimitsReminderEnabled()
					? LimitsReminderAction.fetchLimitsSummary(true)
					: LimitsReminderAction.skip()
			)
		)
	);

	/**
	 * @deprecated - [fabric-deprecated] - Use AccountAppCommand_INTERNAL.GetLimits from app-account instead
	 * */
	getLimitsSummary$ = createEffect(() =>
		this.actions$.pipe(
			ofType(LimitsReminderAction.fetchLimitsSummary),
			map((x) => x.logout),
			switchMap((shouldLogout) =>
				this.service.getCustomerLimits().pipe(
					map((args) =>
						shouldLogout
							? LimitsReminderAction.fetchBeforeLogoutSuccess(args)
							: LimitsReminderAction.fetchLimitsSummarySuccess(args)
					),
					catchError((error: AppError) =>
						shouldLogout
							? of(LimitsReminderAction.fetchBeforeLogoutFailure(error))
							: of(LimitsReminderAction.fetchLimitsSummaryFailure(error))
					)
				)
			)
		)
	);

	getNotificationLimitsSummary$ = createEffect(() =>
		this.actions$.pipe(
			ofType(LimitsReminderAction.fetchNotificationLimitsSummary),
			switchMap(() =>
				this.service.getCustomerLimits().pipe(
					map((args) => LimitsReminderAction.fetchNotificationLimitsSummarySuccess(args)),
					catchError((error: AppError) => of(LimitsReminderAction.fetchLimitsSummaryFailure(error)))
				)
			)
		)
	);

	constructor(
		private actions$: Actions,
		private config: LimitsReminderConfigService,
		private service: LimitsReminderService
	) {}
}
